import { MenuStructure } from '../models/menu.models';

export const MENU_CONFIG: MenuStructure = [
  {
    translationKey: 'liquid.menu.customerinsights',
    icon: 'assets/img/menu-icons/insights.svg',
    items: [
      {
        translationKey: 'liquid.menu.dashboards',
        route: '/insights',
        role: 'loyaltyschemastatistics.data.view',
      },
      {
        translationKey: 'liquid.menu.reporting',
        route: '/insights-plus',
        role: 'menu.reporting.data.view',
      },
    ],
    links: [],
  },
  {
    translationKey: 'liquid.menu.customerdata',
    icon: 'assets/img/menu-icons/customer_data.svg',
    items: [
      {
        translationKey: 'liquid.menu.customers',
        route: '/members',
        role: 'loyaltymember.data.view',
      },
      { translationKey: 'liquid.menu.clubs', route: '/clubs', role: 'clubs.data.view' },
      {
        translationKey: 'liquid.menu.invoices',
        route: '/invoices',
        role: 'loyaltymember.data.invoices.view',
      },
      {
        translationKey: 'liquid.menu.transactions',
        route: '/transactions',
        role: 'loyaltymember.data.transactions.view',
      },
      {
        translationKey: 'page.member-detail.tickets',
        route: '/tickets',
        role: 'tickets.data.view',
      },
    ],
    links: [],
  },
  {
    translationKey: 'liquid.menu.loyaltymodel',
    icon: 'assets/img/menu-icons/loyalty_model.svg',
    items: [
      { translationKey: 'liquid.menu.schemas', route: '/schemas', role: 'loyaltyschema.data.view' },
      {
        translationKey: 'liquid.menu.redeemrules',
        route: '/redeem-rules',
        role: 'loyaltyschema.data.view',
      },
    ],
    links: [],
  },
  {
    translationKey: 'liquid.menu.campaignmanagment',
    icon: 'assets/img/menu-icons/campaign_management.svg',
    items: [
      { translationKey: 'liquid.menu.campaigns', route: '/campaigns', role: 'campaigns.data.view' },
      {
        translationKey: 'liquid.campaign.executions',
        route: '/campaign-executions',
        role: 'campaigns.data.view',
      },
      {
        translationKey: 'menu.marketingactions.managecoupons',
        route: '/coupons',
        role: 'coupon.data.view',
      },
      {
        translationKey: 'menu.marketingactions.managecheckbooks',
        route: '/checkbooks',
        role: 'bookcoupongroup.data.view',
      },
    ],
    links: [],
  },
  {
    translationKey: 'liquid.menu.customeroperations',
    icon: 'assets/img/menu-icons/customer_operation.svg',
    items: [
      {
        translationKey: 'liquid.menu.dataimport',
        route: '/bulk-operations',
        role: 'menu.importdata.view',
      },
    ],
    links: [],
  },
  {
    translationKey: 'liquid.menu.automationcenter',
    icon: 'assets/img/menu-icons/automation_center.svg',
    items: [
      { translationKey: 'liquid.menu.flows', route: '/flows', role: 'flow.action.view' },
      { translationKey: 'liquid.menu.recipes', route: '/recipes', role: 'recipe.action.see' },
    ],
    links: [],
  },
  {
    translationKey: 'liquid.menu.administration',
    icon: 'assets/img/menu-icons/administration.svg',
    items: [
      {
        translationKey: 'liquid.menu.usermanagement',
        route: '/user-management',
        role: 'appuser.data.view',
      },
      {
        translationKey: 'liquid.menu.platformmanagement',
        route: '/platform-management',
        role: 'ciadmin.data.view',
      },
      {
        translationKey: 'liquid.menu.localemanagement',
        route: '/locale-management',
        role: 'menu.localestrings.data.view',
      },
      {
        translationKey: 'liquid.menu.integrationmanagement',
        route: '/integration-management',
        role: 'menu.integrations.data.view',
      },
    ],
    links: [],
  },
  {
    translationKey: 'liquid.menu.datacustomization',
    icon: 'assets/img/menu-icons/administration.svg',
    items: [
      {
        translationKey: 'liquid.menu.stores',
        route: '/store-management',
        role: 'stores.data.view',
      },
      { translationKey: 'liquid.menu.tags', route: '/tag-management', role: 'tags.data.view' },
      { translationKey: 'liquid.menu.brands', route: '/brand-management', role: 'tags.data.view' },
    ],
    links: [],
  },
  {
    translationKey: 'liquid.menu.utilities',
    icon: 'assets/img/menu-icons/utilities.svg',
    items: [],
    links: [
      {
        translationKey: 'liquid.menu.utilities.enbox',
        url: 'https://enbox.inteliqua.com',
        role: 'menu.enbox.data.view',
      },
      {
        translationKey: 'liquid.menu.utilities.itext',
        url: 'https://sms.cloudbiz.eu',
        role: 'menu.itext.data.view',
      },
    ],
  },
  {
    translationKey: 'liquid.contextflow.merchant',
    icon: 'assets/img/menu-icons/customer_data.svg',
    items: [
      {
        translationKey: 'liquid.contextflow.merchant',
        route: '/merchant',
        role: 'merchants.search',
      },
    ],
    links: [],
  },
];
